export default {
  cancellation: {
    DESC_UNKNOWN: '無効なキャンセルポリシーです。',
    DESC_NO_CANCELLATION_AFTER_ISSUED:
      'チケットなどを引換後、または、アクティビティ開始以後のキャンセルは不可となります。',
    DESC_UPTO_X_DAYS_BEFORE_WITH_CHARGE:
      '予約確定日から参加日{{if(P1>0)の{{P1}}日前else当日}}の現地時間{{P2}}まで、{{CancellationFeeDescription}}。',
    DESC_UPTO_X_HOURS_BEFORE_WITH_CHARGE:
      '予約確定日から参加日時の{{P1}}時間前まで、{{CancellationFeeDescription}}。',
    DESC_AFTER_X_DAYS_FROM_TIME_WITH_CHARGE:
      '参加日の{{P1}}日前の現地時間{{P2}}以降、{{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_TIME_WITH_CHARGE:
      '参加日時の{{P1}}時間前以降、{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_DAYS_WITH_CHARGE:
      '参加日の{{P1}}日前の現地時間{{P2}}から{{P3}}日前の現地時間{{P4}}まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_DAYS_TO_Y_HOURS_WITH_CHARGE:
      '参加日の{{P1}}日前の現地時間{{P2}}から当日の現地時間{{P3}}まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_HOURS_WITH_CHARGE:
      '参加日時の{{P1}}時間前から{{P2}}時間前まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_HOURS_TO_0_WITH_CHARGE:
      '参加日時の{{P1}}時間前から参加日当日の現地時間{{P2}}まで、{{CancellationFeeDescription}}',
    DESC_BEFORE_X_DAYS_AFTER_BOOKING_WITH_CHARGE:
      '予約確定日を0日として数えて{{P2}}日目の現地時間{{P1}}まで、{{CancellationFeeDescription}}',
    DESC_BEFORE_X_HOURS_AFTER_BOOKING_WITH_CHARGE:
      '予約確定後の{{P1}}時間前まで、{{CancellationFeeDescription}}',
    DESC_AFTER_X_DAYS_FROM_BOOKING_WITH_CHARGE:
      '予約確定日を0日として数えて{{P2}}日目の現地時間{{P1}}以降、{{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_BOOKING_WITH_CHARGE:
      '予約確定後の{{P1}}時間以降、{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_DAYS_WITH_CHARGE:
      '予約確定日を0日として数えて{{P2}}日目の現地時間{{P1}}から参加日の{{P4}}日前の現地時間{{P3}}まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_HOURS_WITH_CHARGE:
      '予約確定日を0日として数えて{{P2}}日目の現地時間{{P1}}から参加日時の{{P3}}時間前まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_AND_X_HOURS_WITH_CHARGE:
      '予約確定後の{{P1}}時間から参加日時の{{P2}}時間前まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_END_WITH_CHARGE:
      '予約確定日を0日として数えて{{P2}}日目の現地時間{{P1}}から{{P4}}日目の現地時間{{P3}}まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_HOURS_WITH_CHARGE:
      '予約確定日を0日として数えて{{P2}}日目の現地時間{{P1}}から予約確定後の{{P3}}時間前まで、{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_START_AND_END_WITH_CHARGE:
      '予約確定後の{{P1}}時間から予約確定後の{{P2}}時間前まで、{{CancellationFeeDescription}}'
  },
  cancellationFeeDescription: {
    FEE_PERCENTAGE: '注文合計金額の{{value}}%がキャンセル料として発生します',
    FEE_FIXED: '{{value}}のキャンセル料が発生します',
    FEE_PER_PARTICIPANT: '参加者1人あたり{{value}}のキャンセル料が発生します',
    FEE_NOT_TO_BE_CANCELLED: 'キャンセル不可'
  }
};
